import jwt_decode from 'jwt-decode';

export function getDecodedToken(token: string | null): any {
  try {
    if (!token) {
      return;
    }

    return jwt_decode(token);
  } catch (Error) {
    return null;
  }
}
